import { useEffect, useRef } from "react";
import { useDictado, EV_DICTAR, EV_DETENER } from "../voz.ts";

/** Área de texto con botón de dictado por voz (Web Speech API). */
export function Dictador({ texto, setTexto, placeholder, etiqueta = "Texto dictado", alto = 140 }: { texto: string; setTexto: (f: (t: string) => string) => void; placeholder: string; etiqueta?: string; alto?: number }) {
  const voz = useDictado((t) => setTexto((x) => (x ? x.trimEnd() + " " : "") + t));
  const caja = useRef<HTMLTextAreaElement>(null);
  const v = useRef(voz); v.current = voz;
  // «Hola Donna, dicta»: empieza el primer dictado visible de la pantalla; «deja de dictar» los detiene
  useEffect(() => {
    const dictar = (e: Event) => {
      if (e.defaultPrevented || !v.current.soportado || !caja.current?.offsetParent) return;
      e.preventDefault(); caja.current.focus(); caja.current.scrollIntoView({ block: "center", behavior: "smooth" });
      if (!v.current.escuchando) v.current.iniciar();
    };
    const detener = () => { if (v.current.escuchando) v.current.detener(); };
    window.addEventListener(EV_DICTAR, dictar); window.addEventListener(EV_DETENER, detener);
    return () => { window.removeEventListener(EV_DICTAR, dictar); window.removeEventListener(EV_DETENER, detener); };
  }, []);
  return (
    <>
      <textarea ref={caja} className="entrada" style={{ minHeight: alto }} value={texto} onChange={(e) => setTexto(() => e.target.value)} placeholder={placeholder} aria-label={etiqueta} />
      <div className="provisional" aria-live="polite">{voz.provisional}</div>
      <div className="fila">
        {voz.soportado
          ? <button type="button" className={`btn mic${voz.escuchando ? " on" : ""}`} onClick={voz.escuchando ? voz.detener : voz.iniciar} aria-pressed={voz.escuchando}>{voz.escuchando ? "■ Detener dictado" : "● Dictar"}</button>
          : <span className="muted" style={{ fontSize: 13 }}>Este navegador no permite dictar: escribe el texto o usa Chrome/Edge.</span>}
        {voz.error && <span className="aviso error">{voz.error}</span>}
      </div>
    </>
  );
}

